// routes/PrivateRoute.tsx
// import { Navigate, Outlet } from "react-router-dom";
// import { useAuth } from "features/auth/AuthContext"; // your auth provider

// const PrivateRoute = () => {
//   debugger
//   const { isAuthenticated } = useAuth();
//   return isAuthenticated ? <Outlet/> : <Navigate to="/login" />;
// };

// export default PrivateRoute;


import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "features/auth/AuthContext";

const PrivateRoute = () => {
  const { isAuthenticated, isAuthLoading } = useAuth();
  const location = useLocation();

  if (isAuthLoading) {
    return null; // or <Loader /> if you have a spinner
  }

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute;

